<section class="ma__breadcrumbs ma__breadcrumbs--light">
    <nav class="ma__breadcrumbs__container">
        <ol class="ma__breadcrumbs__items">
            <li class="ma__breadcrumbs__item" aria-label="breadcrumbs">
                <a [routerLink]="['/search']">Search Projects</a></li>
            <li class="ma__breadcrumbs__item" aria-label="breadcrumbs" aria-current="page">
                <a>{{projectGeneralInfo!=undefined?projectGeneralInfo.projectName:""}}</a></li>
        </ol>
    </nav>
</section>
<div class="main-content main-content--full">
    <div class="pre-content">
        <div class="ma__page-header">
            <div class="ma__page-header__content">
                <div class="row">
                    <div class="col-md-9">
                        <h2 class="ma__comp-heading float-left">
                            Project:
                            <span style="font-size:1.75rem">&nbsp;{{
                                projectGeneralInfo!=undefined?projectGeneralInfo.projectName:""}}</span>
                        </h2>
                    </div>
                    <div class="col-md-3 col-xs-12">
                        <button class="btn btn-default btn-xs float-right" role="button" title="Print" (click)="Print()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-prefix="fas"
                                data-icon="print" class="svg-inline--fa fa-print fa-w-16" role="img"
                                viewBox="0 0 512 512">
                                <path fill="currentColor"
                                    d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z">
                                </path>
                            </svg>&nbsp;Print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="main-content main-content--two">
    <section class="ma__collapsible-content">
        <div class="ma__collapsible-content__items">
            <div class="ma__collapsible-content__item is-open" id="SearchCollapseDiv">
                <header class="ma__collapsible-header">
                    <div class="ma__collapsible-projectheader" style="padding-left:15px">
                        <h3 class="ma__collapsible-header__title" style="display:inline;">&nbsp;General Information
                        </h3>
                    </div>
                </header>
                <div class="ma__collapsible-content__body collapse show" id="collapseSearch" ma__collapsible-content__body="">
                    <div class="form-row">
                        <div class="col-md-4">
                            <label>EEA No./Project ID</label>
                            <p class="details" id="projectID" type="text">
                                {{projectGeneralInfo!=undefined?projectGeneralInfo.eeaNo:""}}
                            </p>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <label>Address/Location</label>
                            <p class="details">{{projectGeneralInfo.location}}</p>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <label>City/Town</label>
                            <p>{{projectGeneralInfo.cityTown}}</p>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-4 col-xs-12">
                            <label>Project Type</label>
                            <p class="details">{{projectGeneralInfo.projectType}}</p>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <label>Threshold</label>
                            <p class="details">{{projectGeneralInfo.thresholds}}</p>
                        </div>
                        <div class="col-md-4">
                            <label>Agency Actions</label>
                            <p class="details">{{projectGeneralInfo.agencyActions}}</p>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-4 col-xs-12">
                            <label>Archive Status</label>
                            <p class="details">{{projectGeneralInfo.archiveStatus}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ma__collapsible-content">
        <div class="ma__collapsible-content__items">
            <div class="ma__collapsible-content__item is-open" id="ContactsCollapseDiv">
                <header class="ma__collapsible-header">
                    <div class="ma__collapsible-projectheader" style="padding-left:15px">
                        <h3 class="ma__collapsible-header__title" style="display:inline;">&nbsp;Contacts</h3>
                    </div>
                </header>
                <div class="ma__collapsible-content__body collapse show" id="collapseContacts" ma__collapsible-content__body="">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-hover table-condensed table-with-tabs" id="contacts-tab">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        Role/Contact Type&nbsp;
                                    </th>
                                    <th scope="col">
                                        Name&nbsp;
                                    </th>
                                    <th scope="col">
                                        Org/Agency&nbsp;
                                    </th>
                                    <th scope="col">Address</th>
                                    <th scope="col">
                                        City/Town&nbsp;
                                    </th>
                                    <th scope="col">
                                        State
                                    </th>
                                    <th scope="col">
                                        Zip Code&nbsp;
                                    </th>
                                    <th scope="col">Phone No.</th>
                                    <th scope="col">Ext.</th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let contact of contactDetailList">
                                <td>{{contact.contactRoleName}}</td>
                                <td>
                                  {{contact.person?.firstName==null?"":contact.person?.firstName + " "+ contact.person?.lastName==null?"":contact.person?.lastName}}
                                </td>
                                <td>
                                  {{ getDisplayName(contact)}}
                                </td>
                                <td>{{contact.addresses!=null&&contact.addresses.length >0?contact.addresses[0].streetAddress1: ""}}</td>
                                <td>{{contact.addresses!=null&&contact.addresses.length >0?contact.addresses[0].townName: ""}}</td>
                                <td>{{contact.addresses!=null&&contact.addresses.length >0?contact.addresses[0].stateCode: ""}}</td>
                                <td>{{contact.addresses!=null&&contact.addresses.length >0?contact.addresses[0].zipCode: ""}}</td>
                                <td>
                                  {{contact.phones[0]?.phoneNumber==null? "":contact.phones[0]?.phoneNumber}}
                                </td>
                                <td>{{contact.phones[0]?.Extension==null? "":contact.phones[0]?.Extension}}</td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ma__collapsible-content">
        <div class="ma__collapsible-content__items">
            <div class="ma__collapsible-content__item is-open" id="collapseActionDiv">
                <header class="ma__collapsible-header">
                    <div class="ma__collapsible-projectheader" style="padding-left:15px">
                        <h3 class="ma__collapsible-header__title" style="display:inline;">&nbsp;Project Documents
                        </h3>
                    </div>
                </header>
                <div class="ma__collapsible-content__body collapse show" id="collapseActionInfo" ma__collapsible-content__body="">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-hover table-condensed table-with-tabs" id="documents-tab">
                            <thead>
                                <tr>
                                    <th scope="col" (click)="onSort('Submittal Type')" tabindex="0" (keydown.enter)="onSort('Submittal Type')" title="Click to Sort by this column">
                                        Submittal&nbsp;
                                        <svg aria-hidden="true" class="svg-inline--fa fa-sort fa-w-10" data-icon="sort" data-prefix="fas" focusable="false" role="img" viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M 41 288 h 238 c 21.4 0 32.1 25.9 17 41 L 177 448 c -9.4 9.4 -24.6 9.4 -33.9 0 L 24 329 c -15.1 -15.1 -4.4 -41 17 -41 Z m 255 -105 L 177 64 c -9.4 -9.4 -24.6 -9.4 -33.9 0 L 24 183 c -15.1 15.1 -4.4 41 17 41 h 238 c 21.4 0 32.1 -25.9 17 -41 Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </th>
                                    <th scope="col" (click)="onSort('Publish Date')" tabindex="0" (keydown.enter)="onSort('Publish Date')" title="Click to Sort by this column">
                                        Monitor Date&nbsp;
                                        <svg aria-hidden="true" class="svg-inline--fa fa-sort fa-w-10" data-icon="sort" data-prefix="fas" focusable="false" role="img" viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M 41 288 h 238 c 21.4 0 32.1 25.9 17 41 L 177 448 c -9.4 9.4 -24.6 9.4 -33.9 0 L 24 329 c -15.1 -15.1 -4.4 -41 17 -41 Z m 255 -105 L 177 64 c -9.4 -9.4 -24.6 -9.4 -33.9 0 L 24 183 c -15.1 15.1 -4.4 41 17 41 h 238 c 21.4 0 32.1 -25.9 17 -41 Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </th>
                                    <th scope="col">Comments Due Date</th>
                                    <th scope="col" (click)="onSort('Action Date')" tabindex="0" (keydown.enter)="onSort('Action Date')" title="Click to Sort by this column">
                                        Certificate Issuance Date &nbsp;
                                        <svg aria-hidden="true" class="svg-inline--fa fa-sort fa-w-10" data-icon="sort" data-prefix="fas" focusable="false" role="img" viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M 41 288 h 238 c 21.4 0 32.1 25.9 17 41 L 177 448 c -9.4 9.4 -24.6 9.4 -33.9 0 L 24 329 c -15.1 -15.1 -4.4 -41 17 -41 Z m 255 -105 L 177 64 c -9.4 -9.4 -24.6 -9.4 -33.9 0 L 24 183 c -15.1 15.1 -4.4 41 17 41 h 238 c 21.4 0 32.1 -25.9 17 -41 Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </th>
                                    <th scope="col">
                                        Certificate Determination&nbsp;
                                    </th>
                                    <th scope="col" (click)="onSort('Analyst')" tabindex="0" (keydown.enter)="onSort('Analyst')" title="Click to Sort by this column">
                                        Analyst&nbsp;
                                        <svg aria-hidden="true" class="svg-inline--fa fa-sort fa-w-10" data-icon="sort" data-prefix="fas" focusable="false" role="img" viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M 41 288 h 238 c 21.4 0 32.1 25.9 17 41 L 177 448 c -9.4 9.4 -24.6 9.4 -33.9 0 L 24 329 c -15.1 -15.1 -4.4 -41 17 -41 Z m 255 -105 L 177 64 c -9.4 -9.4 -24.6 -9.4 -33.9 0 L 24 183 c -15.1 15.1 -4.4 41 17 41 h 238 c 21.4 0 32.1 -25.9 17 -41 Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </th>
                                    <th scope="col">Withdrawn</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let submission of submissions">
                                    <td><a class="text-link" (click)="GoToSubmittal(submission)" [routerLink]="submission.intake?['/submittal', submission.submittalId ] : []">{{submission.submittalType}}
                                        </a>
                                    </td>
                                    <td>{{submission.publishDate| date :'MMM d, y'}}</td>
                                    <td>{{submission.commentsDueDate| date :'MMM d, y'}}</td>
                                    <td>{{submission.actionDate| date :'MMM d, y'}}</td>
                                    <td>{{submission.determination}}</td>
                                    <td>{{submission.mepaAnalyst}}</td>
                                    <td>{{submission.withdrawn | yesNo}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ma__collapsible-content">
        <div class="ma__collapsible-content__items">
            <div class="ma__collapsible-content__item is-open" id="MeetingCollapse">
                <header class="ma__collapsible-header">
                    <div class="ma__collapsible-projectheader" data-target="#collapseMeeting" style="padding-left:15px">
                        <h3 class="ma__collapsible-header__title" style="display:inline;">&nbsp;Meeting / Site Visit Information
                        </h3>
                    </div>
                </header>
                <div class="ma__collapsible-content__body collapse show" id="collapseMeeting" ma__collapsible-content__body="">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-hover table-condensed table-with-tabs" id="meeting-tab">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        Meeting Type&nbsp;
                                    </th>
                                    <th scope="col">
                                        Date/Time&nbsp;
                                    </th>
                                    <th scope="col">
                                        Location&nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let meeting of meetingList">
                                    <td>{{meeting.meetingType}}</td>
                                    <td>{{meeting.meetingDate}}</td>
                                    <td>{{meeting.location}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <button class="btn btn-default float-left" style="margin-top:20px;" (click)="BackClick()" type="button">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="redo"
            class="svg-inline--fa fa-redo fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="currentColor"
                d="M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z">
            </path>
        </svg>&nbsp;Back
    </button>
</div>
